<div class="column">
  @for (applicant of cardApplicants(); track applicant.applicantId; let i = $index) {
    <ez-applicant-card [applicant]="applicant"
                       [selected]="applicantSelectionStates()[i]"
                       [radioMode]="!isSelectionDisabled()"
                       [inert]="hasSelection() && !applicantSelectionStates()[i]"
                       (selectedChange)="onApplicantSelect(applicant.applicantId, $event)" />
  }
</div>